module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-warn-g-91b52dcbb9e8f28472bb90207a810abc.svg";